// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".large[data-v-6f27ad21]{zoom:120%}.large .v-btn[data-v-6f27ad21]{height:37px;padding:0 85px!important}a[data-v-6f27ad21]{text-decoration:none!important}.mobile.new-consultation-cta-container[data-v-6f27ad21]{position:fixed;left:50%;width:100%;text-align:center;transform:translate(-50%);bottom:0;padding:20px 0;z-index:2;background:linear-gradient(180deg,hsla(0,0%,93.3%,0),rgba(64,64,64,.8))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
